module.exports = __webpack_public_path__ + "img/kz.e08cb0b3.svg";